import { styled } from '@mui/material';
export const LoadingContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    gap: theme.spacing(2),
    cursor: 'default',
}));
